import { render } from "./ProgressMetric.vue?vue&type=template&id=7ac0a4c0"
import script from "./ProgressMetric.vue?vue&type=script&lang=js"
export * from "./ProgressMetric.vue?vue&type=script&lang=js"

import exportComponent from "/srv/www/network4web/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ProgressMetric.vue"]])

export default __exports__